import { TwinDictionary } from './dictionary'
import { stringMatchWithSearch } from './search'

export const reverseArray = <T>(array: T[]) => {
    let reversedArray: T[]= []
    for (let i = array.length - 1; i > -1; i--) {
        reversedArray.push(array[i])
    }
    return reversedArray
}

export const includesByArrayType = (values: any[], value: string) => {
    if (!values.length) {
        return false
    }
    if (typeof values[0] === 'string') {
        return values.includes(String(value))
    } else if (typeof values[0] === 'number') {
        return values.includes(parseInt(value))
    }
}

export const parseIntArray = (arr: string[]) => {
    const result: number[] = []
    for (const id of arr) {
        result.push(parseInt(id))
    }
    return result
}

export const parseStringArray = (arr: any[]) => {
    const result: string[] = []
    for (const id of arr) {
        result.push(String(id))
    }
    return result
}
export const arrayFromDictionaryIdInteger = (dict: TwinDictionary, value: string) => {
    const result: any[] = []
    for (const k in dict) {
        result.push({[value]: parseInt(k)})
    }
    return result
}

export const arrayFromArrayDictionaryAttribute = (arr: TwinDictionary[], value: string = 'id') => {
    const result: any[] = []
    for (const element of arr) {
        result.push(element[value])
    }
    return result
}
export const arrayFromDictionaryAttribute = (dict: TwinDictionary, value: string = 'id') => {
    const result: any[] = []
    for (const key in dict) {
        const element = dict[key]
        result.push(element[value])
    }
    return result
}
export const arrayFromDictionary = (dict: TwinDictionary) => {
    const result: any[] = []
    for (const key in dict) {
        const element = dict[key]
        result.push(element)
    }
    return result
}

export const filterArrayItems = (searchValue: string, arrItems: TwinDictionary[], keyName: string = 'name') => {
    const filteredIArraytems: TwinDictionary[] = []
    for (const value of arrItems) {
        if (stringMatchWithSearch(searchValue, String(value[keyName]))) {
            filteredIArraytems.push(value)
        }
    }
    return filteredIArraytems
}

export const arrFromDictionaryCustomFieldName = (items: TwinDictionary, fieldName: string = 'name', keyName = 'text') => {
    const itemsArr: TwinDictionary[] = []
    for (const key in items) {
        itemsArr.push({ value: key, [keyName]: items[key]?.[fieldName] })
    }
    return itemsArr
}

export const addInventPositionArray = (arrayElements: TwinDictionary[]) => {
    let inventPosition = 0
    const copyArray = JSON.parse(JSON.stringify(arrayElements))
    let dictPosTableData: TwinDictionary = {}
    for (const element of copyArray) {
        element.inventPosition = inventPosition
        element.absoluteIndex = inventPosition
        dictPosTableData[element.id] = inventPosition
        inventPosition++
    }
    return { arrResult: copyArray, dictPosTableData}
}